import React from 'react';
import Icon from '../../../components/AppIcon';

const OperationalAlertPanel = ({ alerts }) => {
  const getPriorityColor = (priority) => {
    if (priority === 'critical') return 'border-l-error bg-error/5';
    if (priority === 'high') return 'border-l-warning bg-warning/5';
    return 'border-l-primary bg-primary/5';
  };

  const getPriorityIcon = (priority) => {
    if (priority === 'critical') return 'AlertTriangle';
    if (priority === 'high') return 'AlertCircle';
    return 'Info';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      equipment: 'Wrench',
      supply: 'Package',
      staff: 'Users',
      quality: 'Shield'
    };
    return icons?.[category] || 'Bell';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Operational Alerts</h2>
          <p className="text-sm text-muted-foreground mt-1">Real-time facility notifications</p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-error/10">
          <Icon name="Bell" size={16} color="var(--color-error)" />
          <span className="text-sm font-semibold text-error">{alerts?.filter(a => a?.priority === 'critical')?.length}</span>
        </div>
      </div>
      <div className="space-y-3 max-h-[600px] overflow-y-auto">
        {alerts?.map((alert) => (
          <div 
            key={alert?.id} 
            className={`border-l-4 ${getPriorityColor(alert?.priority)} p-4 rounded-r-lg transition-smooth hover:shadow-elevation-2`}
          >
            <div className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                alert?.priority === 'critical' ? 'bg-error/10' : 
                alert?.priority === 'high' ? 'bg-warning/10' : 'bg-primary/10'
              }`}>
                <Icon 
                  name={getCategoryIcon(alert?.category)} 
                  size={20} 
                  color={
                    alert?.priority === 'critical' ? 'var(--color-error)' : 
                    alert?.priority === 'high' ? 'var(--color-warning)' : 'var(--color-primary)'
                  }
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="text-sm font-semibold text-foreground">{alert?.title}</h3>
                  <Icon 
                    name={getPriorityIcon(alert?.priority)} 
                    size={16} 
                    color={
                      alert?.priority === 'critical' ? 'var(--color-error)' : 
                      alert?.priority === 'high' ? 'var(--color-warning)' : 'var(--color-primary)'
                    }
                  />
                </div>
                
                <p className="text-sm text-muted-foreground mb-3">{alert?.description}</p>
                
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <div className="flex items-center gap-4">
                    <span className="text-xs text-muted-foreground capitalize">{alert?.category}</span>
                    <span className="text-xs text-muted-foreground">{alert?.timestamp}</span>
                  </div>
                  {alert?.actionRequired && (
                    <span className="text-xs font-medium text-primary">Action Required</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OperationalAlertPanel;